exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PrivacyPolicyModal_checkbox_3GB_T {\n  width: inherit;\n  display: inline-block;\n  margin-top: 16px;\n  margin-right: 4px;\n}\n\n.PrivacyPolicyModal_message_3o8UI a {\n  color: #4a90e2;\n}\n", ""]);

// exports
exports.locals = {
	"checkbox": "PrivacyPolicyModal_checkbox_3GB_T",
	"message": "PrivacyPolicyModal_message_3o8UI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader!./src/ondemand/components/PrivacyPolicyModal/PrivacyPolicyModal.css
// module id = 1206
// module chunks = 2